function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    paragraph\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M36.35,12H3.65a2,2,0,0,1,0-4h32.7a2,2,0,0,1,0,4Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M36.35,22.43H3.65a2,2,0,1,1,0-4h32.7a2,2,0,0,1,0,4Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20,32.85H3.65a2,2,0,1,1,0-4H20a2,2,0,0,1,0,4Z",
  fill: "#231f20"
});

function SvgParagraph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgParagraph;